import { SideNavItems, SideNavSection } from '@modules/navigation/models';

export const sideNavSections: SideNavSection[] = [
    {
        text: 'Check your lease requests',
        items: ['leases', 'billingItems', 'requests'],
    },
];

export const sideNavItems: SideNavItems = {
    leases: {
        icon: 'activity',
        link: '/leases/billing',
        text: 'Leases' },
    billingItems: {
        icon: 'activity',
        link: '/leases/billing',
        text: 'Billing items' },
    requests: {
        icon: 'tool',
        link: '/leases/billing',
        text: 'Submitted Requests' },
    //
    // leases: {
    //     icon: 'activity',
    //     link: '/leases',
    //     text: 'Leases' },
    // billingItems: {
    //     icon: 'activity',
    //     link: '/leases/billing',
    //     text: 'Billing items' },
    // requests: {
    //     icon: 'tool',
    //     link: '/leases/requests',
    //     text: 'Submitted Requests' },
};
